import { DashboardComponentPropsBase } from "components/pages/dashboard/components/interfaces";
import { ReportOptions } from "models/component-print-models";
import { IComponentTheme } from "../product-template-table/utils/interfaces";

export interface TaskTriggerButtonProps extends DashboardComponentPropsBase<ReportOptions>, IComponentTheme {
  label?: string;
  tooltip?: string;
  dagId: string;
  taskId: string;
  icon?: string;
  color?: string;
  useTooltip?: boolean;
  buttonType?: ButtonType;
}

export enum ButtonType {
  LABEL_AND_ICON = "label-and-icon",
  ICON_ONLY = "icon-only",
  LABEL_ONLY = "label-only",
}
